import React from 'react';
import FilterTable from './filterTable';
import { Link } from "react-router-dom";
import './common.css';
import FavoriteItemColumnFormatter from './favoriteItemColumnFormatter';
import extractSearchParams from '../common/extractSearchParams';
import {versionSort} from '../common/arraySort';

const NotActivated = "Not activated";

const PermanentLicenseTable = props => {
  let productNameFilterValues = { 'all': '' };
  props.products.forEach(product => productNameFilterValues[product.name] = product.name);
  let livingStateFilterValues = { 'all': '' };
  props.livingStates.forEach(livingState => livingStateFilterValues[livingState] = livingState);
  let featuresFilterValues = { 'all': '' };
  props.features.forEach((feature) => featuresFilterValues[feature.name] = feature.name);

  const columns = [{
    dataField: 'key',
    text: 'License key',
    sort: true,
    defaultValue: extractSearchParams(props.requestData.location.search, 'license.key'),
    filter_: { type: 'text' },
    headerStyle: () => ({ width: '15em' }),
  }, {
    dataField: 'generationDateTime',
    text: 'Generation date and time',
    sort: true,
    filter_: { type: 'datetime' },
    headerStyle: () => ({ width: '11em' })
  }, {
    dataField: 'supportExpirationDate',
    text: 'Support expiration date',
    sort: true,
    filter_: { type: 'datetime' },
    headerStyle: () => ({ width: '7em' })
  }, {
    dataField: 'productName',
    text: 'Product name',
    sort: true,
    filter_: {
      type: 'select',
      values: productNameFilterValues
    },
    headerStyle: () => ({ width: '7em' })
  }, {
    dataField: 'maxProductVersion',
    text: 'Max version',
    sort: true,
    filter_: { type: 'text' },
    sortFunc: (a, b, order) => versionSort(3, a, b, order)
  }, {
    dataField: 'featuresStr',
    text: 'Features',
    filter_: {
      type: 'select',
      modifier: 'select-weak-comparision',
      values: featuresFilterValues,
    },
  }, {
    dataField: 'activationDateTime',
    text: 'Activation date and time',
    sort: true,
    filter_: { type: 'datetime' },
    headerStyle: () => ({ width: '11em' })
  }, {
    dataField: 'deviceKey',
    text: 'Device key',
    sort: true,
    filter_: { type: 'text' },
    headerStyle: () => ({ width: '12em' }),
    formatter: (cell) => {
      const isKey = cell !== NotActivated;
      return isKey ? <Link to={`/history?device.key=${cell}`}>{cell}</Link> : cell;
    }
  }, {
    dataField: 'livingState',
    text: 'Living state',
    sort: true,
    filter_: {
      type: 'select',
      values: livingStateFilterValues
    },
    headerStyle: () => ({ width: '6em' })
  }, {
    dataField: 'client.fullName',
    text: 'Client',
    filter_: { 
      type: 'text',
      searchable: true,
    },
    sort: true,
  }, 
  {
    dataField: 'temporaryLicense',
    text: 'Temporary license',
    filter_: { 
      type: 'text',
      searchable: true,
    },
    sort: true,
    headerStyle: () => ({ width: '35px' }),
    formatter: (cell) => {
      const keyExists = !!cell;
      return keyExists ? <Link to={`/temporary-licenses?license.key=${cell}`}>{cell}</Link> : '';
    }
  },
  {
    dataField: 'isFavorite',
    text: 'Favorite',
    sort: false,
    align: 'center',
    filter_: {
      type: 'select',
      values: {
        'all': '',
        'favorite': 'true',
      },
    },
    headerStyle: () => ({ width: '35px' }),
    formatter: (cell, row) => <FavoriteItemColumnFormatter
      cell={cell} row={row}
      actions={props.actions}/>,
  }];

  const defaultSorted = [{
    dataField: 'generationDateTime',
    order: 'desc'
  }];

  let permanentLicenses = props.permanentLicenses.map(element => {
    let rElem = { ...element };
    rElem.deviceKey = null;
    if (rElem.device !== null) {
      rElem.deviceKey = rElem.device.key;
    }
    if (rElem.temporaryLicense !== null && rElem.temporaryLicense.key !== null) 
      rElem.temporaryLicense = rElem.temporaryLicense.key;
      else rElem.temporaryLicense = ''
    
    if ((rElem.activationDateTime === null) && (rElem.deviceKey === null)) {
      rElem.deviceKey = NotActivated;
      rElem.activationDateTime = NotActivated;
    }
    rElem.featuresStr = rElem.features === null ? null :
      rElem.features.map(feature => feature.name + (feature.expirationDate !== null ? ` [${feature.expirationDate}]` : '')).join(', ');
    return rElem;
  });

  return (
    <FilterTable
      {...props}
      objectName={'permanentLicenses'}
      data={permanentLicenses}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no permanent licenses"
    />
  );
};

export default PermanentLicenseTable;



// WEBPACK FOOTER //
// ./src/components/permanentLicenseTable.js